import React, { useMemo } from "react";
import BaseTable from "@components/DataTable/BaseTable";
import type { Header } from "@components/DataTable/CustomDataTable.types";
import GenericDialog from "@components/GenericDialog/GenericDialog";
import { t } from "i18next";
import { CREW_LIST_FIELDS } from "../../constants";

const mockDepartureCrewList = [
  {
    id: 1,
    no: 1,
    familyName: "John Skipper",
    rankOrRating: "Master",
    nationality: "American",
    placeOfBirth: "San Francisco, CA",
    dateOfBirth: "05/16/1988",
    gender: "Male",
    natureOfIdentityDocument: "Passport",
    numberOfIdentityDocument: "78123456",
    issuingStateOfIdentityDocument: "USA",
    expiryDate: "26/06/2026",
  },
  {
    id: 2,
    no: 2,
    familyName: "Michael Turner",
    rankOrRating: "Chief Officer",
    nationality: "British",
    placeOfBirth: "Liverpool, UK",
    dateOfBirth: "09/22/1990",
    gender: "Male",
    natureOfIdentityDocument: "Passport",
    numberOfIdentityDocument: "B9234567",
    issuingStateOfIdentityDocument: "UK",
    expiryDate: "15/03/2027",
  },
];

type CrewListDialogProps = {
  testId?: string;
  langBase: string;
  isOpen: boolean;
  setIsCrewListIsOpen: (isOpen: boolean) => void;
};

const CrewListDialog: React.FC<CrewListDialogProps> = ({
  testId,
  langBase,
  isOpen,
  setIsCrewListIsOpen,
}) => {
  const langBaseHeader = `${langBase}.fields`;
  const headers: Header[] = useMemo(
    () => [
      { field: CREW_LIST_FIELDS.NO, columnName: t(`${langBaseHeader}.no`) },
      { field: CREW_LIST_FIELDS.FAMILY_NAME, columnName: t(`${langBaseHeader}.familyName`) },
      { field: CREW_LIST_FIELDS.RANK_OR_RATING, columnName: t(`${langBaseHeader}.rankOrRating`) },
      { field: CREW_LIST_FIELDS.NATIONALITY, columnName: t(`${langBaseHeader}.nationality`) },
      { field: CREW_LIST_FIELDS.PLACE_OF_BIRTH, columnName: t(`${langBaseHeader}.placeOfBirth`) },
      { field: CREW_LIST_FIELDS.DATE_OF_BIRTH, columnName: t(`${langBaseHeader}.dateOfBirth`) },
      { field: CREW_LIST_FIELDS.GENDER, columnName: t(`${langBaseHeader}.gender`) },
      {
        field: CREW_LIST_FIELDS.NATURE_OF_IDENTITY_DOCUMENT,
        columnName: t(`${langBaseHeader}.natureOfIdentityDocument`),
        minWidth: 145,
      },
      {
        field: CREW_LIST_FIELDS.NUMBER_OF_IDENTITY_DOCUMENT,
        columnName: t(`${langBaseHeader}.numberOfIdentityDocument`),
        minWidth: 150,
      },
      {
        field: CREW_LIST_FIELDS.ISSUING_STATE_OF_IDENTITY_DOCUMENT,
        columnName: t(`${langBaseHeader}.issuingStateOfIdentityDocument`),
        minWidth: 150,
      },
      { field: CREW_LIST_FIELDS.EXPIRY_DATE, columnName: t(`${langBaseHeader}.expiryDate`) },
    ],
    [t],
  );

  const formattedFormData = mockDepartureCrewList?.map(
    ({
      id,
      no,
      familyName,
      rankOrRating,
      nationality,
      placeOfBirth,
      dateOfBirth,
      gender,
      natureOfIdentityDocument,
      numberOfIdentityDocument,
      issuingStateOfIdentityDocument,
      expiryDate,
    }) => ({
      id,
      [CREW_LIST_FIELDS.NO]: no ?? "",
      [CREW_LIST_FIELDS.FAMILY_NAME]: familyName ?? "",
      [CREW_LIST_FIELDS.RANK_OR_RATING]: rankOrRating ?? "",
      [CREW_LIST_FIELDS.NATIONALITY]: nationality ?? "",
      [CREW_LIST_FIELDS.PLACE_OF_BIRTH]: placeOfBirth ?? "",
      [CREW_LIST_FIELDS.DATE_OF_BIRTH]: dateOfBirth ?? "",
      [CREW_LIST_FIELDS.GENDER]: gender ?? "",
      [CREW_LIST_FIELDS.NATURE_OF_IDENTITY_DOCUMENT]: natureOfIdentityDocument ?? "",
      [CREW_LIST_FIELDS.NUMBER_OF_IDENTITY_DOCUMENT]: numberOfIdentityDocument ?? "",
      [CREW_LIST_FIELDS.ISSUING_STATE_OF_IDENTITY_DOCUMENT]: issuingStateOfIdentityDocument ?? "",
      [CREW_LIST_FIELDS.EXPIRY_DATE]: expiryDate ?? "",
    }),
  );

  const onClose = () => {
    setIsCrewListIsOpen(false);
  };
  return (
    <GenericDialog
      testId={testId}
      open={isOpen}
      title={t(`${langBase}.crew-list-title`)}
      cancelButtonText={t("common.close")}
      confirmButtonText={t(`${langBase}.add-crew-service-btn`)}
      handleCloseDialog={onClose}
      confirmAction={() => console.log("Add crew service")}
      closeIconAction={onClose}
      maxWidth="xl"
      elementContent={<BaseTable rows={formattedFormData} headers={headers} />}
    />
  );
};

export default CrewListDialog;
